export const transactionTour = [
    {
        id: "payin-report-welcome",
        target: '[data-tour="payin-report-welcome"]',
        title: "Welcome to KWICPE",
        content: "Welcome to the transaction module...",
        disableBeacon: true,
        placement: "center",
        route: "/pay-in",
        buttons: ["skip", "primary"],
    },
    {
        id: "payin-report",
        target: '[data-tour="payin-report"]',
        title: "Payin Report",
        content:
            "View all incoming payment transactions processed through your merchant account. This report helps you monitor transaction activity and payment status in real time.",
        placement: "right",
        route: "/pay-in",
        isFixed: true,
    },
    {
        id: "search-transactions",
        target: '[data-tour="search-transactions"]',
        title: "Search Transactions",
        content:
            "Search for a specific transaction using Order ID.",
        // content:
        //     "Search for a specific transaction using Order ID, Transaction ID, Customer Details, or other available identifiers.",
        placement: "top",
        route: "/pay-in",
    },
    {
        id: "refresh-data",
        target: '[data-tour="refresh-data"]',
        title: "Refresh Data",
        content:
            "Click the refresh button to reload the report and retrieve the latest transaction information.",
        placement: "top",
        route: "/pay-in",
    },
    {
        id: "filter-by-date",
        target: '[data-tour="filter-by-date"]',
        title: "Filter by Date",
        content:
            "Use the date filter to view Payin transactions for a specific day, custom date range, or predefined periods such as Today, Yesterday, Last 7 Days, and This Month.",
        placement: "top",
        route: "/pay-in",
    },
    {
        id: "transaction-records",
        target: '[data-tour="transaction-records"]',
        title: "Transaction Records",
        content:
            "Review all Payin transactions including Order ID, Transaction Mode, Amount, Commission, Rolling Reserve, Status, Transaction Date, and Updated Date.",
        placement: "top",
        route: "/pay-in",
    },
    {
        id: "payment-status",
        target: '[data-tour="payment-status"]',
        title: "Payment Status",
        content:
            "Track the current status of each transaction, such as Processing, Success, Failed, Pending, or other payment states.",
        placement: "bottom",
        route: "/pay-in",
    },
    {
        id: "transaction-details",
        target: '[data-tour="transaction-details"]',
        title: "Transaction Details",
        content:
            "Click the View button to access complete transaction information, including payment details, customer information, timestamps, and processing history.",
        placement: "left",
        route: "/pay-in",
    },
    {
        id: "navigate-records",
        target: '[data-tour="navigate-records"]',
        title: "Navigate Records",
        content:
            "Use the pagination controls to browse through multiple pages of transaction records.",
        placement: "top",
        route: "/pay-in",
    },
    // {
    //     id: "payin-report-complete",
    //     target: "body",
    //     title: "🎉 Great!",
    //     content:
    //         "You have completed the Payin Report walkthrough. You can now search, filter, monitor, and review all incoming payment transactions from a single location.",
    //     placement: "center",
    //     route: "/pay-in",
    // },
    // =========================
    // PAYOUT TOUR
    // =========================
    {
        id: "payout-report",
        target: '[data-tour="payout-report"]',
        title: "Pay Out Report Overview",
        content:
            "View and manage all payout transactions processed through your merchant account. This report provides complete visibility into payout activity, transfer status, and settlement information.",
        placement: "right",
        route: "/pay-out-report",
        isFixed: true,
    },
    {
        id: "filter-payout-transactions",
        target: '[data-tour="filter-payout-transactions"]',
        title: "Filter Transactions",
        content:
            "Use the date filter and search bar to quickly find payout transactions for a specific period or transaction reference.",
        placement: "top",
        route: "/pay-out-report",
    },
    {
        id: "payout-transfer-details",
        target: '[data-tour="payout-transfer-details"]',
        title: "Transfer Details",
        content:
            "Review important payout information including Order ID, Transfer Mode, Amount, Commission, Transaction Date, and Updated Date.",
        placement: "top",
        route: "/pay-out-report",
    },
    {
        id: "payout-status",
        target: '[data-tour="payout-status"]',
        title: "Transaction Status",
        content:
            "Monitor the current payout status of each transaction, such as Settled, Processing, or Failed.",
        placement: "bottom",
        route: "/pay-out-report",
    },
    {
        id: "payout-transaction-details",
        target: '[data-tour="payout-transaction-details"]',
        title: "View Transaction Details",
        content:
            "Click the View button to access detailed information about a specific payout transaction, including beneficiary and processing details.",
        placement: "left",
        route: "/pay-out-report",
    },
    {
        id: "payout-record-navigation",
        target: '[data-tour="payout-record-navigation"]',
        title: "Navigate Records",
        content:
            "Use the pagination controls to browse through multiple pages of payout transaction records.",
        placement: "top",
        route: "/pay-out-report",
    },

    // =========================
    // FINAL STEP
    // =========================
    {
        id: "transaction-tour-complete",
        target: "body",
        title: "🎉 Great!",
        content:
            "You have completed both the Payin and Payout Report walkthroughs. You can now search, filter, monitor, and review all incoming and outgoing transactions from your merchant dashboard.",
        placement: "center",
        route: "/pay-out-report",
    },
];